<script setup lang="ts">
import useAppStore from '@/stores/app';
import HeaderMenuItem from '@/layouts/main/header/components/HeaderMenuItem.vue';
import HeaderMobileMenu from '@/layouts/main/header/components/HeaderMobileMenu.vue';

// Instances
const appStore = useAppStore();

// Data
const {menu} = storeToRefs(appStore);
</script>

<template>
    <nav
        v-if="menu.length > 0"
        aria-label="Header navigation"
    >
        <div class="hidden items-center space-x-8 md:flex">
            <template v-for="item in menu" :key="item.id">
                <HeaderMenuItem
                    :item="item"
                    block
                />
            </template>
        </div>

        <HeaderMobileMenu
            class="md:hidden"
            :menu="menu"
        />
    </nav>
</template>

<style scoped>

</style>
